import { WithDisposable } from '@cbi-blocksuite/block-std';
import { t } from '@cbi-blocksuite/blocks';
import { css, html, LitElement, nothing, svg } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';

import type { CbiDocInfo } from './cbi-doc-info.js';

const hideIcon = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.26307 7.32485L2.26425 7.32558L2.26993 7.32905L2.2948 7.34412C2.31728 7.35764 2.35137 7.37796 2.39618 7.4041C2.48583 7.4564 2.61824 7.53191 2.78623 7.62291C3.1226 7.80511 3.59965 8.0483 4.16036 8.29128C5.29436 8.78268 6.71872 9.25005 8.00001 9.25005C9.28131 9.25005 10.7057 8.78268 11.8397 8.29128C12.4004 8.0483 12.8774 7.80511 13.2138 7.62291C13.3818 7.53191 13.5142 7.4564 13.6038 7.4041C13.6487 7.37796 13.6828 7.35764 13.7052 7.34412L13.7301 7.32905L13.7358 7.32558L13.7368 7.32492C13.9716 7.17967 14.2798 7.25212 14.4251 7.48688C14.5705 7.72167 14.498 8.02984 14.2632 8.17519L14 7.75005C14.2632 8.17519 14.2633 8.17512 14.2632 8.17519L14.2596 8.17743L14.2512 8.18253L14.2209 8.20091C14.1947 8.21668 14.1567 8.23933 14.1077 8.26788C14.0099 8.32496 13.8682 8.4057 13.6901 8.5022C13.3341 8.695 12.8304 8.9518 12.2373 9.20883C11.0636 9.71743 9.48795 10.2501 8.00001 10.2501C6.51207 10.2501 4.93644 9.71743 3.76275 9.20883C3.16961 8.9518 2.66589 8.695 2.30995 8.5022C2.13179 8.4057 1.99016 8.32496 1.89231 8.26788C1.84337 8.23933 1.80535 8.21668 1.77914 8.20091L1.7488 8.18253L1.74048 8.17743L1.73807 8.17595L1.73703 8.17531C1.73693 8.17524 1.73684 8.17519 2.00001 7.75005L1.73703 8.17531C1.50224 8.02996 1.42953 7.72167 1.57488 7.48688C1.7202 7.25213 2.02829 7.17963 2.26307 7.32485C2.26307 7.32485 2.26306 7.32484 2.26307 7.32485Z" fill="#6D6E6F"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 9.75C8.27614 9.75 8.5 9.97386 8.5 10.25V12.25C8.5 12.5261 8.27614 12.75 8 12.75C7.72386 12.75 7.5 12.5261 7.5 12.25V10.25C7.5 9.97386 7.72386 9.75 8 9.75Z" fill="#6D6E6F"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3707 9.26707C10.6374 9.1956 10.9116 9.3539 10.983 9.62063L11.5007 11.5525C11.5721 11.8192 11.4138 12.0934 11.1471 12.1649C10.8804 12.2363 10.6062 12.078 10.5347 11.8113L10.0171 9.87945C9.94563 9.61271 10.1039 9.33855 10.3707 9.26707Z" fill="#6D6E6F"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.62945 9.2671C5.89618 9.33858 6.05447 9.61274 5.983 9.87948L5.46536 11.8113C5.39389 12.0781 5.11972 12.2364 4.85299 12.1649C4.58626 12.0934 4.42797 11.8192 4.49944 11.5525L5.01707 9.62066C5.08855 9.35393 5.36271 9.19563 5.62945 9.2671Z" fill="#6D6E6F"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2504 8.31689C3.48954 8.45497 3.57148 8.76076 3.43341 8.99991L2.43341 10.732C2.29534 10.9711 1.98954 11.053 1.7504 10.915C1.51125 10.7769 1.42931 10.4711 1.56738 10.232L2.56738 8.49991C2.70545 8.26076 3.01125 8.17882 3.2504 8.31689Z" fill="#6D6E6F"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7504 8.31689C12.9895 8.17882 13.2953 8.26076 13.4334 8.49991L14.4334 10.232C14.5715 10.4711 14.4895 10.7769 14.2504 10.915C14.0112 11.053 13.7055 10.9711 13.5674 10.732L12.5674 8.99991C12.4293 8.76076 12.5112 8.45497 12.7504 8.31689Z" fill="#6D6E6F"/>
</svg>
`;
const showIcon = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.25C6.22546 4.25 4.62349 4.88581 3.4614 5.73927C2.87988 6.16635 2.39754 6.65588 2.05675 7.16206C1.71951 7.66296 1.5 8.21223 1.5 8.75C1.5 9.28777 1.71951 9.83704 2.05675 10.3379C2.39754 10.8441 2.87988 11.3337 3.4614 11.7607C4.62349 12.6142 6.22546 13.25 8 13.25C9.77445 13.25 11.3764 12.6147 12.5386 11.7614C13.1201 11.3344 13.6025 10.8449 13.9433 10.3386C14.2806 9.83755 14.5 9.28809 14.5 8.75C14.5 8.21191 14.2806 7.66245 13.9433 7.16139C13.6025 6.6551 13.1201 6.16559 12.5386 5.73861C11.3764 4.88534 9.77445 4.25 8 4.25ZM2.5 8.75C2.5 8.47745 2.61627 8.12157 2.88627 7.72054C3.15272 7.32478 3.54906 6.9156 4.05333 6.54526C5.06281 5.80388 6.46084 5.25 8 5.25C9.53925 5.25 10.9373 5.80352 11.9467 6.54467C12.451 6.91491 12.8473 7.32401 13.1137 7.71981C13.3837 8.12084 13.5 8.47695 13.5 8.75C13.5 9.02305 13.3837 9.37916 13.1137 9.7802C12.8473 10.176 12.451 10.5851 11.9467 10.9553C10.9373 11.6965 9.53925 12.25 8 12.25C6.46084 12.25 5.06281 11.6961 4.05333 10.9547C3.54906 10.5844 3.15272 10.1752 2.88627 9.77946C2.61627 9.37843 2.5 9.02255 2.5 8.75ZM8 6.25C6.61929 6.25 5.5 7.36929 5.5 8.75C5.5 10.1307 6.61929 11.25 8 11.25C9.38071 11.25 10.5 10.1307 10.5 8.75C10.5 7.36929 9.38071 6.25 8 6.25ZM6.5 8.75C6.5 7.92158 7.17158 7.25 8 7.25C8.82842 7.25 9.5 7.92158 9.5 8.75C9.5 9.57842 8.82842 10.25 8 10.25C7.17158 10.25 6.5 9.57842 6.5 8.75Z" fill="#6D6E6F"/>
</svg>
`;

@customElement('cbi-doc-info-menu')
export class CbiDocInfoMenu extends WithDisposable(LitElement) {
  static override styles = css`
    .overlay-mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: var(--affine-z-index-popover);
    }

    .cbi-doc-info-menu-container {
      z-index: var(--affine-z-index-popover);
      user-select: none;
    }

    .cbi-doc-info-menu {
      position: fixed;
      left: 0;
      top: 0;
      width: 240px;
      max-height: 240px;
      overflow-y: auto;
      box-sizing: border-box;
      font-size: var(--affine-font-base);
      padding-top: 8px;
      display: flex;
      flex-direction: column;
      background: var(--affine-background-overlay-panel-color);
      box-shadow: var(--affine-shadow-2);
      border-radius: 6px;
      z-index: var(--affine-z-index-popover);
      /* transition: max-height 0.2s ease-in-out; */

      .menu-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 5px 24px 5px 16px;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
      }
      .menu-item:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
      .menu-item.active {
        color: #8b4eef;
      }
      .divider {
        padding-top: 8px;
        border-bottom: 1px solid var(--30_Disabled, #eceae9);
      }
    }
  `;

  @property({ attribute: false })
  anchorEl!: HTMLDivElement;

  @property({ attribute: false })
  block!: CbiDocInfo;

  @query('.cbi-doc-info-menu')
  menuElement?: HTMLElement;

  abortController = new AbortController();
  closeTimer!: ReturnType<typeof setTimeout>;

  close = () => {
    this.abortController.abort();
    // @ts-ignore
    this.anchorEl = null;
    this.block?.rootElement.classList.remove('menu-open');
  };

  handleMouseEnter = () => {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  };
  handleMouseLeave = () => {
    this.closeTimer = setTimeout(() => {
      this.close();
    }, 500);
  };

  override render() {
    const { anchorEl, block } = this;
    if (!anchorEl) return nothing;
    if (!block) return nothing;
    const {
      hideMediaProducer,
      hideScriptWriter,
      hideCreatedOn,
      hideDueDate,
      hideDocInfo,
      docInfo,
      updateInfoInMeta,
    } = block;
    const { top, left, height } = anchorEl.getBoundingClientRect();

    return html`<div class="cbi-doc-info-menu-container blocksuite-overlay">
      <div class="overlay-mask" @click="${this.close}"></div>
      <div
        class="cbi-doc-info-menu"
        style="top: ${top + height + 10}px; left: ${left}px;"
        @mouseenter=${this.handleMouseEnter}
        @mouseleave=${this.handleMouseLeave}
      >
        <div class="menu">
          <div>
            ${!docInfo.scriptWriter
              ? nothing
              : html`
                  <div
                    class="menu-item"
                    @click=${() => {
                      updateInfoInMeta(
                        'hideScriptWriter',
                        hideScriptWriter ? 0 : 1
                      );
                    }}
                  >
                    ${t('scriptWriter')}
                    ${hideScriptWriter ? hideIcon : showIcon}
                  </div>
                `}
            ${!docInfo.mediaProducer
              ? nothing
              : html`
                  <div
                    class="menu-item"
                    @click=${() => {
                      updateInfoInMeta(
                        'hideMediaProducer',
                        hideMediaProducer ? 0 : 1
                      );
                    }}
                  >
                    ${t('mediaProducer')}
                    ${hideMediaProducer ? hideIcon : showIcon}
                  </div>
                `}
            ${!docInfo.createdAt
              ? nothing
              : html`
                  <div
                    class="menu-item"
                    @click=${() => {
                      updateInfoInMeta('hideCreatedOn', hideCreatedOn ? 0 : 1);
                    }}
                  >
                    ${t('createdOn')} ${hideCreatedOn ? hideIcon : showIcon}
                  </div>
                `}
            ${!docInfo.dueDate
              ? nothing
              : html`
            <div
              class="menu-item"
              @click=${() => {
                updateInfoInMeta('hideDueDate', hideDueDate ? 0 : 1);
              }}
            >
              ${t('dueDate')} ${hideDueDate ? hideIcon : showIcon}
            </div>
          </div>
          `}
            <div class="divider"></div>
            <div
              class="menu-item"
              @click=${() => {
                updateInfoInMeta('hideDocInfo', hideDocInfo ? 0 : 1);
                this.close();
              }}
            >
              ${t('Hide document info')}
            </div>
          </div>
        </div>
      </div>
    </div>`;
  }
}
